export const TilemapType = Object.freeze({
  WALL: "W",
  TILE: "T",
  FURNITURE: "F",
  OCCUPIED: "O",
  PLAYER: "P",
});
